<p-steps
  [model]="steps"
  [activeIndex]="activeStep"></p-steps>

@if ((loading$ | async) === false) {
  @if (!activeStep) {
    <p-card styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Период</label>
          <crm-daterangepicker
            [value]="[billsQueryParams.from, billsQueryParams.to]"
            (changeValue)="setDateFilters($event)"
            appendTo="body"></crm-daterangepicker>
        </div>

        <div class="field">
          <label class="font-medium">Компания</label>
          <crm-company-single-select
            [(selectedCompany)]="selectedCompany"
            appendTo="body">
          </crm-company-single-select>
        </div>

        <div class="field">
          <label class="font-medium">Контрагент</label>
          <crm-contragent-auto-complete
            [(selectedContragent)]="selectedContragent"
            [customSearch]="false"></crm-contragent-auto-complete>
        </div>
      </div>
    </p-card>

    <div class="mt-3 flex justify-content-end">
      <crm-button
        [disabled]="!isValidFirstStep"
        label="Далее"
        icon="pi pi-arrow-right"
        styleClass="p-button-success"
        (onClick)="changeStep()"></crm-button>
    </div>
  } @else if (activeStep === 1) {
    <p-card styleClass="mt-3">
      <div class="max-h-29rem overflow-y-auto overflow-x-hidden">
        <crm-table
          [columns]="columns"
          [values]="bills">
          <ng-template
            #rowTemplate
            let-item="item">
            @if (toItem(item); as item) {
              <tr>
                <td>
                  <div class="field-checkbox mb-0">
                    <p-checkbox
                      [ngModel]="selectItems.includes(item.erp1cNumber)"
                      [binary]="true"
                      (ngModelChange)="selectItem(item)"></p-checkbox>
                  </div>
                </td>
                <td>
                  {{ item.erp1cNumber }}
                </td>
                <td>
                  <crm-change-field-in-card [enabledMenu]="false">
                    <ng-template #infoTemplate>
                      <p>{{ item.date ? (item.date | date: 'dd MMMM yyyy') : 'Отсутствует' }}</p>
                    </ng-template>
                    <ng-template #editTemplate>
                      <crm-datepicker
                        [isNotCheckedExternal]="true"
                        [(value)]="item.date"
                        appendTo="body"></crm-datepicker>
                    </ng-template>
                  </crm-change-field-in-card>
                </td>
                <td>
                  @for (document of item.documents; track document.code; let isLast = $last) {
                    <a
                      (click)="editDocument(document.code)"
                      class="cursor-pointer">
                      {{ document.code }}</a
                    ><span *ngIf="!isLast">, </span>
                  }
                </td>
              </tr>
            }
          </ng-template>
        </crm-table>
      </div>
    </p-card>

    <div class="mt-3 flex align-items-center gap-3">
      <crm-button
        label="Назад"
        icon="pi pi-arrow-left"
        styleClass="p-button-secondary p-button-text"
        (onClick)="activeStep = 0"></crm-button>
      <crm-button
        [disabled]="!selectItems.length"
        label="Создать"
        styleClass="p-button-success"
        (onClick)="create()"></crm-button>
    </div>
  }
} @else {
  <crm-spinner></crm-spinner>
}
